export const openNewTab = (url?: string): boolean => {
    if (url === undefined || url === "") {
        return false;
    }

    window.open(url, "_blank");
    return true;
};